export default function getTypeName(obj: any): string {
  return obj?.constructor?.name;
}
